import * as React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import SidebarContainer from 'src/modules/Routing/Sidebar/SidebarContainer';
import { providerInitialStats, IProvidersStatsResult, IProviderStatisticsResponse } from 'src/share/types/provider';
import { StatisticsService, StatsTypes } from 'src/share/services/statistics';
import { Filter } from 'src/share/components/Filter/Filter';
import ProviderStatsContainer from './components/ProviderStatsContainer';
import { IntervalTypes, intervalOptions } from 'src/share/utils/intervals';
import { RoutesModules } from 'src/modules/Routing/types';
import './providersStats.css';

export interface IProvidersStatsProps {
}

export interface IProvidersStatsState {
  ICMECStats: IProvidersStatsResult;
  webIQStats: IProvidersStatsResult;
  loading: boolean;
  toggleFilter: boolean;
  selected: IntervalTypes;
}

export class ProvidersStats extends React.Component<IProvidersStatsProps, IProvidersStatsState> {
  constructor(props: IProvidersStatsProps) {
    super(props);
    this.state = {
      ICMECStats: { ...providerInitialStats },
      webIQStats: { ...providerInitialStats },
      loading: true,
      toggleFilter: false,
      selected: 'day'
    }
  }

  public componentDidMount() {
    this.loadData(this.state.selected);
  }

  public async loadData(interval: IntervalTypes) {
    this.setState({ loading: true });
    const { webIQStats, ICMECStats }: IProviderStatisticsResponse = await StatisticsService.getProvidersStats(StatsTypes.PROVIDERS, interval);
    this.setState({ webIQStats, ICMECStats, loading: false });
  }

  public toggleFilterInterval = (selected) => {
    const optionSelected = typeof selected === "string";
    this.setState((state) => ({
      toggleFilter: !state.toggleFilter,
      selected: optionSelected ? selected as IntervalTypes : state.selected
    }), () => optionSelected && this.loadData(selected as IntervalTypes));
  }

  public render() {
    const { ICMECStats, webIQStats, loading, selected } = this.state;
    return (
      <Scrollbars
        style={{ width: '100%' }}
        autoHeigh={true}
        autoHide={true}
        autoHideTimeout={1000}
        autoHideDuration={200}
      >
        <div className="providers-stats">
          <Filter selected={selected} options={intervalOptions} changeStatus={this.toggleFilterInterval} />
          <div className="col-12">
            <ProviderStatsContainer interval={selected} stats={ICMECStats} provider={'ICMEC'} loading={loading} />
            <ProviderStatsContainer interval={selected} stats={webIQStats} provider={'WebIQ'} loading={loading} />
          </div>
        </div>
      </Scrollbars>
    );
  }
}

export default SidebarContainer(RoutesModules.ADMIN)(ProvidersStats);
